import { create } from 'zustand';

interface SalesCopilotModalStore {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useSalesCopilotModalStore = create<SalesCopilotModalStore>(
  (set) => ({
    isOpen: false,
    openModal: () => set({ isOpen: true }),
    closeModal: () => set({ isOpen: false }),
  })
);
